import Vue from 'vue'

/**
 * @author Jose Luis R
 * @param id Sinister id
 * @return {Object}
 */

const service = ({ id }, payload) =>
  Vue.$http.put(`sinisters/affected/change_required_files_LV/${id}/`, payload)
    .then(response => response.data)


export default service



// WEBPACK FOOTER //
// ./src/services/purchase/lifting/setRequiredLiftingFiles.js